import { render, staticRenderFns } from "./ThePersonList.vue?vue&type=template&id=fe5c4f76&"
import script from "./ThePersonList.vue?vue&type=script&lang=js&"
export * from "./ThePersonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports